import React, { Suspense } from 'react';
import { useRoutes } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PrivateRoute from './PrivateRoute';
import PrivateRouteInfotools from './PrivateRouteInfotools';
import Root from './Root';
import * as layoutConstants from '../constants/layout';
// All layouts/containers
import DefaultLayout from '../layouts/Default';
import InfotoolsLayout from '../layouts/Infotools';
import VerticalLayout from '../layouts/Vertical';
import DetachedLayout from '../layouts/Detached';
import HorizontalLayout from '../layouts/Horizontal';
// import VerticalSimpleLayout from '../layouts/VerticalSimple';
import FullLayout from '../layouts/Full';
import RolRoute from './RolRoute';
import ChunkLoadBoundary from '../components/ChunkLoadBoundary';

//* Auth
const Login = React.lazy(() => import('../pages/account/Login'));
const Logout = React.lazy(() => import('../pages/account/Logout'));

//* Auth Infotools
const LoginInfotools = React.lazy(() => import('../pages/Infotools/front/account/Login'));
const LogoutInfotools = React.lazy(() => import('../pages/Infotools/front/account/Logout'));
const ConfigurationInfotools = React.lazy(() => import('../pages/Infotools/front/account/Configuration'));

//* Dashboard
const Dashboard = React.lazy(() => import('../pages/dashboard'))

//* No se usa (?)
// const ErrorPageNotFoundAlt = React.lazy(() => import('../pages/error/PageNotFoundAlt'));

//* Administración
const Users = React.lazy(() => import('../pages/Administration/users'))
const UsersForm = React.lazy(() => import('../pages/Administration/users/form'))

const Roles = React.lazy(() => import('../pages/Administration/roles'))
const RolesForm = React.lazy(() => import('../pages/Administration/roles/form'))

const Offices = React.lazy(() => import('../pages/Administration/oficinas'))
const OfficesForm = React.lazy(() => import('../pages/Administration/oficinas/form'))

const Languages = React.lazy(() => import('../pages/Administration/languages'))
const Dictionary = React.lazy(() => import('../pages/Administration/languages/dictionary'))

const PrivacyPolicy = React.lazy(() => import('../pages/Administration/privacyPolicy'))
const PrivacyPolicyForm = React.lazy(() => import('../pages/Administration/privacyPolicy/form'))

const PrintConf = React.lazy(() => import('../pages/Administration/printConf'))

const Logs = React.lazy(() => import('../pages/Administration/logs'))

const FormulariosInternos = React.lazy(() => import('../pages/Administration/formulariosInternos'))
const FormulariosInternosForm = React.lazy(() => import('../pages/Administration/formulariosInternos/form'))

const QRConf = React.lazy(() => import('../pages/Administration/qr'))

//* Contents
const Estructura = React.lazy(() => import('../pages/Contents/structure'))

const Noticias = React.lazy(() => import('../pages/Contents/news'))
const NoticiasForm = React.lazy(() => import('../pages/Contents/news/form'))
const CustomDbNews = React.lazy(() => import('../pages/Contents/news/form/customDbNews'))
const Borradores = React.lazy(() => import('../pages/Contents/news/borradores'))
const Archive = React.lazy(() => import('../pages/Contents/news/archive'))

const Eventos = React.lazy(() => import('../pages/Contents/events'))
const EventosForm = React.lazy(() => import('../pages/Contents/events/form'))
const RRSSCertificationsServices = React.lazy(() => import('../pages/Contents/events/rrssCertificationsServices'))
const BorradoresEventos = React.lazy(() => import('../pages/Contents/events/borradores'))
const Schedule = React.lazy(() => import('../pages/Contents/events/schedule'))

const GuiasDocumentos = React.lazy(() => import('../pages/Contents/guidesDocuments'))
const GuiasDocumentosForm = React.lazy(() => import('../pages/Contents/guidesDocuments/form'))
const Categorias = React.lazy(() => import('../pages/Contents/guidesDocuments/categories'))

const Pois = React.lazy(() => import('../pages/Contents/pois'))
const CategoriasPois = React.lazy(() => import('../pages/Contents/pois/categories'))
const PoisForm = React.lazy(() => import('../pages/Contents/pois/form'))

const Rutas = React.lazy(() => import('../pages/Contents/routes'))
const RutasForm = React.lazy(() => import('../pages/Contents/routes/form'))
const CategoriasRuta = React.lazy(() => import('../pages/Contents/routes/categories'))
const ImportRuta = React.lazy(() => import('../pages/Contents/routes/import'))

const Travels = React.lazy(() => import('../pages/Contents/travels'))
const TravelsForm = React.lazy(() => import('../pages/Contents/travels/form'))
const CategoriesTravel = React.lazy(() => import('../pages/Contents/travels/categories'))

const Contacts = React.lazy(() => import('../pages/Contents/contacts'))
const ContactsForm = React.lazy(() => import('../pages/Contents/contacts/form'))
const DatabaseContacts = React.lazy(() => import('../pages/Contents/contacts/database'))
const ActivitiesContacts = React.lazy(() => import('../pages/Contents/contacts/activities'))

const Experiences = React.lazy(() => import('../pages/Contents/experiences'))
const ExperiencesForm = React.lazy(() => import('../pages/Contents/experiences/form'))
const CategoriesExperiences = React.lazy(() => import('../pages/Contents/experiences/categories'))

//* ERP
const Accommodations = React.lazy(() => import('../pages/ERP/accommodations'))
const AccommodationsForm = React.lazy(() => import('../pages/ERP/accommodations/form'))

//* Infotools
const Enlaces = React.lazy(() => import('../pages/Infotools/enlaces'))
const EnlacesForm = React.lazy(() => import('../pages/Infotools/enlaces/form'))
const CategoriasEnlaces = React.lazy(() => import('../pages/Infotools/enlaces/categories'))
const Incidencias = React.lazy(() => import('../pages/Infotools/incidencias'))
const IncidenciasForm = React.lazy(() => import('../pages/Infotools/incidencias/form'))
const History = React.lazy(() => import('../pages/Infotools/incidencias/history'))

const TipoIncidencias = React.lazy(() => import('../pages/Infotools/tiposIncidencias'))
const TipoIncidenciasForm = React.lazy(() => import('../pages/Infotools/tiposIncidencias/form'))

const EstadisticasInfotools = React.lazy(() => import('../pages/Infotools/estadisticas'))

const InfotoolsFront = React.lazy(() => import('../pages/Infotools/front'))

const ConfigInfotools = React.lazy(() => import('../pages/Infotools/configuration'))
const ConfigInfotoolsForm = React.lazy(() => import('../pages/Infotools/configuration/form'))
const UsersInfotools = React.lazy(() => import('../pages/Infotools/users'))
const UsersInfotoolsForm = React.lazy(() => import('../pages/Infotools/users/form'))

//* Registro de Visitantes
const Medios = React.lazy(() => import('../pages/RegistroVisitantes/medios'))
const TiposVisitante = React.lazy(() => import('../pages/RegistroVisitantes/tiposVisitante'));
const TiposSolicitante = React.lazy(() => import('../pages/RegistroVisitantes/tiposSolicitante'));
const RangosEdad = React.lazy(() => import('../pages/RegistroVisitantes/rangosEdad'));
const Procedencias = React.lazy(() => import('../pages/RegistroVisitantes/procedencias'));
const Demandas = React.lazy(() => import('../pages/RegistroVisitantes/demandas'));
const InsercionMasiva = React.lazy(() => import('../pages/RegistroVisitantes/insercionMasiva'));
const Estadisticas = React.lazy(() => import('../pages/RegistroVisitantes/estadisticas'));
const Comparativas = React.lazy(() => import('../pages/RegistroVisitantes/comparativas'));
const ConfigurationRV = React.lazy(() => import('../pages/RegistroVisitantes/configuration'));

//* Encuestas
const Encuestas = React.lazy(() => import('../pages/Surveys/gestion'))
const EncuestasForm = React.lazy(() => import('../pages/Surveys/gestion/form'))
const ConfiguracionEncuestas = React.lazy(() => import('../pages/Surveys/gestion/configuration'));
const TraduccionEncuestas = React.lazy(() => import('../pages/Surveys/gestion/form/multiLang'));

//* Estadísticas de Encuestas */
const SurveyStats = React.lazy(() => import('../pages/Surveys/estadisticas'));
//* Estadisticas de Encuesta filtrado por Registro de Visitantes
const SurveyStatsWithRegistration = React.lazy(() => import('../pages/Surveys/estadisticas/withRegistration'));

// * Digital Signage
const Devices = React.lazy(() => import('../pages/Digital-Signage/devices'));
const DevicesForm = React.lazy(() => import('../pages/Digital-Signage/devices/form'));
const DevicesGroups = React.lazy(() => import('../pages/Digital-Signage/devices-groups'));
const DevicesGroupsForm = React.lazy(() => import('../pages/Digital-Signage/devices-groups/form'));

//* Otros
const ErrorPageNotFound = React.lazy(() => import('../pages/error/PageNotFound'));
const ServerError = React.lazy(() => import('../pages/error/ServerError'));
const ServerError2 = React.lazy(() => import('../pages/error/ServerError2'));
const CategoriesItems = React.lazy(() => import('../pages/previews/CategoriesItems'));
const DocumentItem = React.lazy(() => import('../pages/previews/DocumentItem'));
const InfoData = React.lazy(() => import('../pages/Infotools/front/InfoData'));
const Surveyator = React.lazy(() => import('../pages/Surveys/Surveyator'));

//* Opinometro
const OpinometerConf = React.lazy(() => import('../pages/Opinometro/conf'));
const OpinometerManagement = React.lazy(() => import('../pages/Opinometro'));
const OpinometerForm = React.lazy(() => import('../pages/Opinometro/form'));
const OpinometerStats = React.lazy(() => import('../pages/Opinometro/stats'));

// * Formularios Internos
const InternalFormsDetail = React.lazy(() => import('../pages/FormulariosInternos'));
const InternalFormsForm = React.lazy(() => import('../pages/FormulariosInternos/form'));

// * Estado de la mar
const SeaConfig = React.lazy(() => import('../pages/Sea/config'));
const SeaLogs = React.lazy(() => import('../pages/Sea/logs'));
const SeaStats = React.lazy(() => import('../pages/Sea/stats'));

const loading = () => <div className=""></div>;

type LoadComponentProps = {
    component: React.LazyExoticComponent<() => JSX.Element>,
};

const LoadComponent = ({ component: Component }: LoadComponentProps) => (
    <ChunkLoadBoundary>
        <Suspense fallback={loading()}>
            <Component />
        </Suspense>
    </ChunkLoadBoundary>
);

const AllRoutes = () => {
    const { layout } = useSelector((state) => ({
        layout: state.Layout,
    }));

    const getLayout = () => {
        let layoutCls = VerticalLayout;

        switch (layout.layoutType) {
            case layoutConstants.LAYOUT_HORIZONTAL:
                layoutCls = HorizontalLayout;
                break;
            case layoutConstants.LAYOUT_DETACHED:
                layoutCls = DetachedLayout;
                break;
            case layoutConstants.LAYOUT_FULL:
                layoutCls = FullLayout;
                break;
            default:
                layoutCls = VerticalLayout;
                break;
        }
        return layoutCls;
    };
    let Layout = getLayout();

    return useRoutes([
        { path: '/', element: <Root /> },
        {
            // public routes
            path: '/',
            element: <DefaultLayout />,
            children: [
                {
                    path: 'account',
                    children: [
                        { path: 'login', element: <LoadComponent component={Login} /> },
                        { path: 'logout', element: <LoadComponent component={Logout} /> }
                    ],
                },
                {
                    path: 'error-404',
                    element: <LoadComponent component={ErrorPageNotFound} />,
                },
                {
                    path: 'error-500',
                    element: <LoadComponent component={ServerError} />,
                },
                {
                    path: "infotools",
                    children: [
                        {
                            path: 'login',
                            element: <LoadComponent component={LoginInfotools} />
                        },
                        {
                            path: 'logout',
                            element: <LoadComponent component={LogoutInfotools} />
                        },
                        {
                            path: 'configuration',
                            element: <LoadComponent component={ConfigurationInfotools} />
                        }
                    ]
                },
            ],
        },
        {
            path: '',
            element: <PrivateRouteInfotools component={InfotoolsLayout} />,
            children: [
                {
                    path: "infotools",
                    children: [
                        {
                            path: "",
                            element: <LoadComponent component={InfotoolsFront} />
                        }
                    ]
                }
            ]
        },
        {
            path: '',
            element: <InfotoolsLayout />,
            children: [
                {
                    path: 'infoData',
                    children: [
                        {
                            path: ':idOffice/:lang/:id',
                            element: <LoadComponent component={InfoData} />
                        }
                    ]
                },
                {
                    path: 'surveyator',
                    children: [
                        {
                            path: ':id',
                            element: <LoadComponent component={Surveyator} />
                        }
                    ]
                },
                {
                    path: 'preview-categories',
                    children: [
                        {
                            path: ':id',
                            element: <LoadComponent component={CategoriesItems} />
                        }
                    ]
                },
                {
                    path: 'preview-documents',
                    children: [
                        {
                            path: ':id',
                            element: <LoadComponent component={DocumentItem} />
                        }
                    ]
                },
            ]
        },
        {
            // auth protected routes
            path: '/',
            element: <PrivateRoute component={Layout} />,
            children: [
                {
                    path: 'dashboard',
                    element: <LoadComponent component={Dashboard} />,
                },
                {
                    path: 'ad-users',
                    children: [
                        {
                            path: '',
                            element: <RolRoute module='ad-users' action='menu' component={Users} />
                        },
                        {
                            path: 'add',
                            element: <RolRoute module='ad-users' action='create' component={UsersForm} />
                        },
                        {
                            path: ':id',
                            element: <RolRoute module='ad-users' action='menu' component={UsersForm} /> //! para que pueda modificar sus propios datos
                        },
                        {
                            path: 'self/:id',
                            element: <LoadComponent component={UsersForm} /> //! para que pueda modificar sus propios datos
                        }
                    ]
                },
                {
                    path: 'ad-offices',
                    children: [
                        {
                            path: '',
                            element: <RolRoute module='ad-offices' action='menu' component={Offices} />
                        },
                        {
                            path: 'add',
                            element: <RolRoute module='ad-offices' action='create' component={OfficesForm} />
                        },
                        {
                            path: ':id',
                            element: <RolRoute module='ad-offices' action='menu' component={OfficesForm} />
                        }
                    ]
                },
                {
                    path: 'ad-roles',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='ad-roles' action='menu' component={Roles} />,
                        },
                        {
                            path: 'add',
                            element: <RolRoute module='ad-roles' action='create' component={RolesForm} />,
                        },
                        {
                            path: ':id',
                            element: <RolRoute module='ad-roles' action='menu' component={RolesForm} />
                        }
                    ]
                },
                {
                    path: 'ad-languages',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='ad-languages' action='menu' component={Languages} />,
                        },
                        {
                            path: 'dictionary',
                            children: [
                                {
                                    path: ":code",
                                    element: <RolRoute module='ad-languages' action='menu' component={Dictionary} />,
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'ad-privacy-policy',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='ad-privacy-policy' action='menu' component={PrivacyPolicy} />,
                        },
                        {
                            path: 'add',
                            children: [
                                {
                                    path: ":language",
                                    element: <RolRoute module='ad-privacy-policy' action='menu' component={PrivacyPolicyForm} />,
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'ad-print-conf',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='ad-print-conf' action='menu' component={PrintConf} />,
                        },
                    ]
                },
                {
                    path: 'ad-qr-conf',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='ad-qr-conf' action='menu' component={QRConf} />,
                        },
                    ]
                },
                {
                    path: 'ad-logs',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='ad-logs' action='menu' component={Logs} />,
                        },
                    ]
                },
                {
                    path: 'ad-internal-forms',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='ad-internal-forms' action='menu' component={FormulariosInternos} />,
                        },
                        {
                            path: 'add',
                            element: <RolRoute module='ad-internal-forms' action='create' component={FormulariosInternosForm} />,
                        },
                        {
                            path: ':id',
                            element: <RolRoute module='ad-internal-forms' action='menu' component={FormulariosInternosForm} />
                        }
                    ]
                },
                {
                    path: 'cts-news',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='cts-news' action='menu' component={Noticias} />,
                        },
                        {
                            path: 'add',
                            element: <RolRoute module='cts-news' action='create' component={NoticiasForm} />,
                        },
                        {
                            path: ':id',
                            element: <RolRoute module='cts-news' action='menu' component={NoticiasForm} />
                        },
                        {
                            path: 'customDbNews',
                            element: <RolRoute module='cts-news' action='menu' component={CustomDbNews} />,
                        },
                        {
                            path: 'newsDraft',
                            element: <RolRoute module='cts-news' action='menu' component={Borradores} />,
                        },
                        {
                            path: 'archive',
                            element: <RolRoute module='cts-news' action='menu' component={Archive} />,
                        },
                    ]
                },
                {
                    path: 'cts-structure',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='cts-structure' action='menu' component={Estructura} />,
                        }
                    ]
                },
                {
                    path: 'cts-events',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='cts-events' action='menu' component={Eventos} />,
                        },
                        {
                            path: 'add',
                            element: <RolRoute module='cts-events' action='create' component={EventosForm} />,
                        },
                        {
                            path: ':id',
                            element: <RolRoute module='cts-events' action='menu' component={EventosForm} />
                        },
                        {
                            path: 'customDbNews',
                            element: <RolRoute module='cts-events' action='menu' component={CustomDbNews} />,
                        },
                        {
                            path: 'rrssCertificationsServices',
                            element: <RolRoute module='cts-events' action='menu' component={RRSSCertificationsServices} />,
                        },
                        {
                            path: 'eventsDraft',
                            element: <RolRoute module='cts-events' action='menu' component={BorradoresEventos} />,
                        },
                        {
                            path: 'schedule',
                            element: <RolRoute module='cts-events' action='menu' component={Schedule} />,
                        }
                    ]
                },
                {
                    path: 'cts-guides-documents',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='cts-guides-documents' action='menu' component={GuiasDocumentos} />,
                        },
                        {
                            path: 'add',
                            element: <RolRoute module='cts-guides-documents' action='create' component={GuiasDocumentosForm} />,
                        },
                        {
                            path: ':id',
                            element: <RolRoute module='cts-guides-documents' action='menu' component={GuiasDocumentosForm} />
                        },
                        {
                            path: 'categories',
                            element: <RolRoute module='cts-guides-documents' action='menu' component={Categorias} />,
                        }
                    ]
                },
                {
                    path: 'cts-pois',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='cts-pois' action='menu' component={Pois} />,
                        },
                        {
                            path: 'add',
                            element: <RolRoute module='cts-pois' action='create' component={PoisForm} />,
                        },
                        {
                            path: ':id',
                            element: <RolRoute module='cts-pois' action='menu' component={PoisForm} />
                        },
                        {
                            path: 'categories',
                            element: <RolRoute module='cts-pois' action='menu' component={CategoriasPois} />,
                        }
                    ]
                },
                {
                    path: 'cts-routes',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='cts-routes' action='menu' component={Rutas} />,
                        },
                        {
                            path: 'add',
                            element: <RolRoute module='cts-routes' action='create' component={RutasForm} />,
                        },
                        {
                            path: ':id',
                            element: <RolRoute module='cts-routes' action='menu' component={RutasForm} />
                        },
                        {
                            path: 'categories',
                            element: <RolRoute module='cts-routes' action='menu' component={CategoriasRuta} />,
                        },
                        {
                            path: 'import',
                            element: <RolRoute module='cts-routes' action='menu' component={ImportRuta} />,
                        }
                    ]
                },
                {
                    path: 'cts-experiences',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='cts-experiences' action='menu' component={Experiences} />,
                        },
                        {
                            path: 'add',
                            element: <RolRoute module='cts-experiences' action='create' component={ExperiencesForm} />,
                        },
                        {
                            path: ':id',
                            element: <RolRoute module='cts-experiences' action='menu' component={ExperiencesForm} />
                        },
                        {
                            path: 'categories',
                            element: <RolRoute module='cts-experiences' action='menu' component={CategoriesExperiences} />,
                        },
                    ]
                },
                {
                    path: 'cts-travels',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='cts-travels' action='menu' component={Travels} />,
                        },
                        {
                            path: 'add',
                            element: <RolRoute module='cts-travels' action='create' component={TravelsForm} />,
                        },
                        {
                            path: ':id',
                            element: <RolRoute module='cts-travels' action='menu' component={TravelsForm} />
                        },
                        {
                            path: 'categories',
                            element: <RolRoute module='cts-travels' action='menu' component={CategoriesTravel} />,
                        }
                    ]
                },
                {
                    path: 'cts-contacts',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='cts-contacts' action='menu' component={Contacts} />
                        },
                        {
                            path: 'add',
                            element: <RolRoute module='cts-contacts' action='create' component={ContactsForm} />,
                        },
                        {
                            path: ':id',
                            element: <RolRoute module='cts-contacts' action='menu' component={ContactsForm} />
                        },
                        {
                            path: 'database',
                            element: <RolRoute module='cts-contacts' action='menu' component={DatabaseContacts} />,
                        },
                        {
                            path: 'activities',
                            element: <RolRoute module='cts-contacts' action='menu' component={ActivitiesContacts} />,
                        }
                    ]
                },
                {
                    path: 'erp-contacts',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='cts-contacts' action='menu' component={Contacts} />
                        },
                        {
                            path: 'add',
                            element: <RolRoute module='cts-contacts' action='create' component={ContactsForm} />,
                        },
                        {
                            path: ':id',
                            element: <RolRoute module='cts-contacts' action='menu' component={ContactsForm} />
                        },
                        {
                            path: 'database',
                            element: <RolRoute module='cts-contacts' action='menu' component={DatabaseContacts} />,
                        },
                        {
                            path: 'activities',
                            element: <RolRoute module='cts-contacts' action='menu' component={ActivitiesContacts} />,
                        }
                    ]
                },
                {
                    path: 'erp-accommodations',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='erp-accommodations' action='menu' component={Accommodations} />,
                        },
                        {
                            path: ":id",
                            element: <RolRoute module='erp-accommodations' action='create' component={AccommodationsForm} />,
                        }
                    ]
                },
                {
                    path: 'it-links',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='it-links' action='menu' component={Enlaces} />,
                        },
                        {
                            path: "add",
                            element: <RolRoute module='it-links' action='create' component={EnlacesForm} />,
                        },
                        {
                            path: ":id",
                            element: <RolRoute module='it-links' action='menu' component={EnlacesForm} />,
                        },
                        {
                            path: 'categories',
                            element: <RolRoute module='it-links' action='menu' component={CategoriasEnlaces} />,
                        }
                    ]
                },
                {
                    path: 'it-issues',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='it-issues' action='menu' component={Incidencias} />,
                        },
                        {
                            path: "add",
                            element: <RolRoute module='it-issues' action='create' component={IncidenciasForm} />,
                        },
                        {
                            path: ":id",
                            element: <RolRoute module='it-issues' action='menu' component={IncidenciasForm} />,
                        },
                        {
                            path: 'history',
                            children: [
                                {
                                    path: ":id",
                                    element: <RolRoute module='it-issues' action='menu' component={History} />,
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'it-stats',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='it-stats' action='create' component={EstadisticasInfotools} />
                        }
                    ]
                },
                {
                    path: 'it-type-issues',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='it-type-issues' action='menu' component={TipoIncidencias} />,
                        },
                        {
                            path: "add",
                            element: <RolRoute module='it-type-issues' action='create' component={TipoIncidenciasForm} />,
                        },
                        {
                            path: ":id",
                            element: <RolRoute module='it-type-issues' action='menu' component={TipoIncidenciasForm} />,
                        }
                    ]
                },
                {
                    path: 'it-configuration',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='it-configuration' action='menu' component={ConfigInfotools} />,
                        },
                        {
                            path: "add",
                            element: <RolRoute module='it-configuration' action='create' component={ConfigInfotoolsForm} />,
                        },
                        {
                            path: ":id",
                            element: <RolRoute module='it-configuration' action='menu' component={ConfigInfotoolsForm} />,
                        }
                    ]
                },
                {
                    path: 'it-users',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='it-users' action='menu' component={UsersInfotools} />,
                        },
                        {
                            path: "add",
                            element: <RolRoute module='it-users' action='create' component={UsersInfotoolsForm} />,
                        },
                        {
                            path: ":id",
                            element: <RolRoute module='it-users' action='menu' component={UsersInfotoolsForm} />,
                        }
                    ]
                },
                {
                    path: 'visireg-conf',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='visireg-conf' action='menu' component={ConfigurationRV} />
                        }
                    ]
                },
                {
                    path: 'visireg-medias',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='visireg-medias' action='menu' component={Medios} />
                        }
                    ]
                },
                {
                    path: 'visireg-visitor-types',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='visireg-visitor-types' action='menu' component={TiposVisitante} />
                        }
                    ]
                },
                {
                    path: 'visireg-applicant-types',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='visireg-applicant-types' action='menu' component={TiposSolicitante} />
                        }
                    ]
                },
                {
                    path: 'visireg-ages',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='visireg-ages' action='menu' component={RangosEdad} />
                        }
                    ]
                },
                {
                    path: 'visireg-origins',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='visireg-origins' action='menu' component={Procedencias} />
                        }
                    ]
                },
                {
                    path: 'visireg-demands',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='visireg-demands' action='menu' component={Demandas} />
                        }
                    ]
                },
                {
                    path: 'visireg-massive',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='visireg-massive' action='create' component={InsercionMasiva} />
                        }
                    ]
                },
                {
                    path: 'visireg-stats',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='visireg-stats' action='create' component={Estadisticas} />
                        }
                    ]
                },
                {
                    path: 'visireg-comparisons',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='visireg-comparisons' action='create' component={Comparativas} />
                        }
                    ]
                },
                {
                    path: 'srv-management',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='srv-management' action='menu' component={Encuestas} />,
                        },
                        {
                            path: 'add',
                            element: <RolRoute module='srv-management' action='create' component={EncuestasForm} />,
                        },
                        {
                            path: ':id',
                            element: <RolRoute module='srv-management' action='menu' component={EncuestasForm} />
                        },
                        {
                            path: 'configuration',
                            element: <RolRoute module='srv-management' action='menu' component={ConfiguracionEncuestas} />
                        },
                        {
                            path: 'translate/:id',
                            element: <RolRoute module='srv-management' action='menu' component={TraduccionEncuestas} />
                        }
                    ]
                },
                {
                    path: 'srv-stats',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='srv-stats' action='menu' component={SurveyStats} />
                        }
                    ]
                },
                {
                    path: 'srv-stats-reg',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='srv-stats-reg' action='menu' component={SurveyStatsWithRegistration} />
                        }
                    ]
                },
                {
                    path: 'opinometer-conf',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='opinometer-conf' action='menu' component={OpinometerConf} />
                        }
                    ]
                },
                {
                    path: 'opinometer-management',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='opinometer-management' action='menu' component={OpinometerManagement} />,
                        },
                        {
                            path: "add",
                            element: <RolRoute module='opinometer-management' action='create' component={OpinometerForm} />,
                        },
                        {
                            path: ":id",
                            element: <RolRoute module='opinometer-management' action='menu' component={OpinometerForm} />,
                        }
                    ]
                },
                {
                    path: 'opinometer-stats',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='opinometer-stats' action='menu' component={OpinometerStats} />
                        }
                    ]
                },
                {
                    path: 'devices',
                    children: [
                        {
                            path: "",
                            element: <RolRoute module='ds-devices' action='menu' component={Devices} />
                        },
                        {
                            path: "add",
                            element: <RolRoute module='ds-devices' action='create' component={DevicesForm} />
                        },
                        {
                            path: ":id",
                            element: <RolRoute module='ds-devices' action='menu' component={DevicesForm} />
                        },
                        {
                            path: "groups",
                            children: [
                                {
                                    path: "",
                                    element: <RolRoute module='ds-devices-groups' action='menu' component={DevicesGroups} />
                                },
                                {
                                    path: "add",
                                    element: <RolRoute module='ds-devices-groups' action='create' component={DevicesGroupsForm} />
                                },
                                {
                                    path: ":id",
                                    element: <RolRoute module='ds-devices-groups' action='menu' component={DevicesGroupsForm} />
                                }
                            ]
                        },
                    ]
                },
                {
                    path: 'internal-forms',
                    children: [
                        {
                            path: ":id",
                            children: [
                                {
                                    path: "",
                                    element: <RolRoute module='internal-forms-internal' action='menu' component={InternalFormsDetail} />
                                },
                                {
                                    path: "add",
                                    element: <RolRoute module='internal-forms-internal' action='create' component={InternalFormsForm} />
                                },
                                {
                                    path: ":idInstance",
                                    element: <RolRoute module='internal-forms-internal' action='menu' component={InternalFormsForm} />
                                }
                            ]

                        }
                    ]
                },
                {
                    path: 'sea-config',
                    element: <RolRoute module='sea-config' action='menu' component={SeaConfig} />
                },
                {
                    path: 'sea-logs',
                    element: <RolRoute module='sea-logs' action='menu' component={SeaLogs} />
                },
                {
                    path: 'sea-stats',
                    element: <RolRoute module='sea-stats' action='menu' component={SeaStats} />
                },
                {
                    path: 'server-error',
                    element: <LoadComponent component={ServerError2} />,
                },
                {
                    path: '*',
                    element: <LoadComponent component={ErrorPageNotFound} />,
                }
            ],
        },
    ]);
};

export { AllRoutes };
